import { AppCapability } from '~~/utils/auth/roleCapabilityMatrix'
import type { OnboardingTourDefinition } from './types'

function normalizePath(path: string): string {
  const trimmed = path.trim()
  if (trimmed === '') {
    return '/'
  }
  return trimmed.replace(/\/+$/, '') || '/'
}

function isNationalRoute(path: string): boolean {
  return normalizePath(path) === '/'
}

export const ONBOARDING_TOURS: OnboardingTourDefinition[] = [
  {
    id: 'org-read-guided-pdl',
    version: 1,
    displayTitle: 'Découverte Nationale et Direction Régionale PDL',
    displayDescription: 'Comprendre la vue nationale et naviguer jusqu’à la Direction Régionale PDL.',
    icon: 'tour',
    entryPath: '/',
    forceRedoOnUpdate: true,
    requiredCapabilities: [AppCapability.ORG_READ],
    routeMatcher: isNationalRoute,
    steps: [
      {
        id: 'intro',
        title: 'Bienvenue dans Mon Orga',
        description:
          'On commence sur la vue Nationale, puis vous irez dans la "Direction" PDL pour voir les niveaux "Domaine" et "Agence".',
        expectedPath: '/',
      },
      {
        id: 'national-middle-cards',
        selector: '[data-onboarding="national-middle-cards-target"]',
        title: 'Cartes principales',
        description:
          'Ces cartes sont vos points d’entrée vers les Directions. Elles structurent la navigation.',
        side: 'top',
        expectedPath: '/',
      },
      {
        id: 'national-pdl-card',
        selector: '[data-onboarding="national-direction-pdl"]',
        title: 'Direction Régionale PDL',
        description:
          'Cliquez sur la carte PDL pour ouvrir la Direction. Le tutoriel continuera automatiquement une fois sur la page.',
        expectedPath: '/',
        requiredPathPrefix: '/PDL',
        requiredPathMessage: 'Ouvrez la Direction Régionale PDL avant de continuer ce tutoriel.',
      },
      {
        id: 'direction-layer',
        selector: '[data-onboarding="direction-title"]',
        title: 'Niveau Direction',
        description:
          'La Direction représente le niveau de pilotage principal de l’organigramme DR PDL.',
        side: 'bottom',
        expectedPath: '/PDL',
        requiredPathPrefix: '/PDL',
      },
      {
        id: 'direction-domaines',
        selector: '[data-onboarding="direction-domaine-header"]',
        title: 'Niveau Domaine',
        description:
          'Chaque en-tête de colonne représente un Domaine de la Direction Régionale PDL.',
        expectedPath: '/PDL',
        requiredPathPrefix: '/PDL',
      },
      {
        id: 'direction-agences',
        selector: '[data-onboarding="direction-agence-item"]',
        title: 'Niveau Agence',
        description:
          'Dans un Domaine, les cartes représentent les Agences. En ouvrant une Agence, vous accédez ensuite aux Équipes.',
        expectedPath: '/PDL',
        requiredPathPrefix: '/PDL',
      },
      {
        id: 'toolbox-entry',
        selector: '[data-onboarding="toolbox-fab"]',
        title: 'Toolbox',
        description:
          'Ouvrez la toolbox pour afficher ses actions. Tant qu’elle n’est pas ouverte, vous ne pouvez pas continuer.',
        openToolbox: true,
        side: 'left',
      },
      {
        id: 'toolbox-geolocate',
        selector: '[data-onboarding="toolbox-geolocate"]',
        title: 'Me situer',
        description:
          'Depuis la toolbox, "Me situer" vous positionne automatiquement dans l’organigramme selon vos rattachements.',
        side: 'left',
        openToolbox: true,
      },
      {
        id: 'toolbox-edit-mode',
        selector: '[data-onboarding="toolbox-edit-mode"]',
        title: 'Mode édition',
        description:
          'Le bouton mode édition affiche les actions de modification quand vos droits et votre périmètre le permettent.',
        side: 'left',
        openToolbox: true,
      },
    ],
  },
]
